import { publicRequest } from '../api/client/publicRequest'
import { DEFAULT_FEES_STYLE } from '../constants'

export interface IConfigs {
  BASE_URL: string
  CLIENT_ID: string
  CLIENT_SECRET: string
  STRIPE_PUBLISHABLE_KEY: string
  X_SOURCE_ORIGIN: string
  FEES_STYLE?: string
  [key: string]: string | number | undefined
}

export const CONFIGS: IConfigs = { FEES_STYLE: DEFAULT_FEES_STYLE } as IConfigs

export const setConfigs = (
  configs: Partial<IConfigs> &
    Pick<
      IConfigs,
      | 'BASE_URL'
      | 'CLIENT_ID'
      | 'CLIENT_SECRET'
      | 'STRIPE_PUBLISHABLE_KEY'
      | 'X_SOURCE_ORIGIN'
    >
) => {
  Object.keys(configs).forEach((key) => {
    const value = configs[key as keyof IConfigs]
    if (value !== undefined) {
      CONFIGS[key] = value
    }
  })

  publicRequest.setBaseUrl(CONFIGS.BASE_URL)
}
